module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_photogenic@3x-c942cff2d132f6dec2c6edcd448f3fbb.webp";